import { html, ref, repeat } from '@microsoft/fast-element';
import {
  AdvisorCompanyGrid,
  AdvisorUserByCompany,
  BuyerAdvisorCompany,
  LinkAdvisorsCompany,
} from './link-advisors';
import { closeIcon, nextStepIcon } from '../../../../styles';
import { LinkAdvisorsCompanyRow } from './company-rows/company-rows';

LinkAdvisorsCompanyRow;

export const LinkAdvisorsTemplate = html<LinkAdvisorsCompany>`
  <fast-dialog class="default-dialog" ${ref('linkAdvisorsModal')}>
    <div class="dialog-header">
      <div class="title">Advisor Management</div>
      <zero-button appearance="stealth" @click="${(x) => x.close()}" class="closing-icon">
        ${closeIcon}
      </zero-button>
    </div>
    <div class="dialog-body">
      <div class="company-card">
        <div class="card-title">Buyer Companies</div>
        <zero-text-field
          placeholder="Search..."
          class="search-bar"
          ${ref('buyerCompanySearch')}
          ?disabled=${(x, c) => x.currentAdvisorCompany != ''}
          @keyup=${(x, c) => x.handleSearch(AdvisorCompanyGrid.BUYER)}
        ></zero-text-field>
        <div class="table-container">
          <table class="grid ${(x) => (x.currentAdvisorCompany != '' ? 'disabled-table' : '')}">
            <tr class="header-row">
              <th class="radio-cell"></th>
              <th class="name-header">Name</th>
              <th class="info-cell"></th>
            </tr>
            ${repeat(
              (x) => x.filteredBuyerCompanyData,
              html<BuyerAdvisorCompany>`
                <company-row
                  :data=${(x) => x}
                  :selected=${(x, c) => c.parent.currentBuyerCompany === x.COMPANY_ID}
                  class="${(x, c) => (c.parent.currentAdvisorCompany != '' ? 'disabled' : '')}"
                  :disabled=${(x, c) => c.parent.currentAdvisorCompany != ''}
                  @buyer-company-selected=${(x, c) =>
                    c.parent.handleCompanyRadioSelect(x.COMPANY_ID, AdvisorCompanyGrid.BUYER)}
                ></company-row>
              `,
              { positioning: true }
            )}
          </table>
        </div>
      </div>
      <div class="next-step-icon">${nextStepIcon()}</div>
      <div class="company-card">
        <div class="card-title">Advisor Companies</div>
        <zero-text-field
          placeholder="Search..."
          class="search-bar"
          ?disabled=${(x, c) => x.currentBuyerCompany === ''}
          ${ref('advisorCompanySearch')}
          @keyup=${(x, c) => x.handleSearch(AdvisorCompanyGrid.ADVISOR)}
        ></zero-text-field>
        <div
          class="table-container ${(x) => (x.currentBuyerCompany === '' ? 'disabled-table' : '')}"
        >
          <table class="grid">
            <tr class="header-row">
              <th class="radio-cell"></th>
              <th class="name-header">Name</th>
            </tr>
            ${repeat(
              (x) => x.filteredAdvisorCompanyData,
              html`
                <tr class="${(x, c) => (c.parent.currentBuyerCompany === '' ? 'disabled' : '')}">
                  <td class="icon-cells radio-cell">
                    <zero-radio
                      current-checked=${(x, c) =>
                        c.parent.currentAdvisorCompany === x.CASCADE_COMPANY_ID}
                      @click=${(x, c) =>
                        c.parent.handleCompanyRadioSelect(
                          x.CASCADE_COMPANY_ID,
                          AdvisorCompanyGrid.ADVISOR
                        )}
                    ></zero-radio>
                  </td>
                  <td>${(x) => x.NAME}</td>
                </tr>
              `
            )}
          </table>
        </div>
      </div>
      <div class="next-step-icon">${nextStepIcon()}</div>
      <div class="users-card">
        <div class="card-title">Advisor Users</div>
        <zero-text-field
          placeholder="Search..."
          class="search-bar"
          @keyup=${(x, c) => x.handleSearch(AdvisorCompanyGrid.USER)}
          ${ref('advisorUserCompanySearch')}
        ></zero-text-field>
        <div class="table-container">
          <table class="grid">
            <tr class="header-row">
              <th class="radio-cell"></th>
              <th class="name-header">Name</th>
              <th class="name-header">User Role</th>
              <th class="name-header">Assigned Buyer Company(s)</th>
            </tr>
            ${repeat(
              (x) => x.filteredAdvisorUsersData,
              html<AdvisorUserByCompany>`
                <tr>
                  <td class="icon-cells">
                    <zero-checkbox
                      :checked=${(x) => x?.ASSIGNED}
                      @click=${(x, c) => (x.ASSIGNED = !x.ASSIGNED)}
                    ></zero-checkbox>
                  </td>
                  <td>${(x) => (x.NAME ? x.NAME : x.USERNAME)}</td>
                  <td>${(x) => x.ROLES}</td>
                  <td>${(x) => x.ASSIGNED_COMPANIES}</td>
                </tr>
              `
            )}
          </table>
        </div>
      </div>
    </div>
    <div class="dialog-footer">
      <zero-button
        appearance="primary"
        @click="${(x) => x.updateAssignments()}"
        ?disabled="${(x) =>
          x.currentBuyerCompany === '' ||
          x.currentAdvisorCompany === '' ||
          x.advisorUsersData?.length === 0}"
      >
        Update Assignments
      </zero-button>
    </div>
  </fast-dialog>
`;
